// extracted by extract-css-chunks-webpack-plugin
module.exports = {"piaohong":"piaohong-AMj_4nQg","piaohonglink":"piaohonglink-1Hjhw-yp","close":"close-1hNt9-I6"};